import React, { useState, useEffect, useMemo } from "react";
import BusinessDataService from "../services/BusinessService";
import { useSelector } from 'react-redux';
import BeautifulTable from "../../components/BeautifulTable";
import { fNumber } from "../../utils/formatNumber";

const BusinessUser = (props) => {
  const [business, setBusiness] = useState([]);

  const { user: currentUser } = useSelector((state) => state.auth);
  const currentUserId = currentUser?.id || currentUser?._id;

  useEffect(() => {
    if (currentUserId) {
      retrieveBusiness();
    }
  }, [currentUserId]); // eslint-disable-line

  const retrieveBusiness = () => {
    BusinessDataService.getAll(currentUserId)
      .then((response) => setBusiness(response.data ?? response))
      .catch((e) => console.log(e));
  };

  const columns = useMemo(
    () => [
      { Header: "Date", accessor: "date", Cell: ({ value }) => (value ? new Date(value).toLocaleDateString() : "") },
      { Header: "Amount", accessor: "amount", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Transaction type", accessor: "creditOrDebit", Cell: ({ value }) => (value === "credit" ? "Buy" : (value === "debit" ? "Repayment" : (value || ""))) },
      { Header: "Tenor", accessor: "tenor", Cell: ({ value, row }) => (row?.original?.creditOrDebit === "credit" ? (value ? `${value} Months` : "—") : "—") },
      { Header: "Description", accessor: "description" },
      { Header: "New Balance", accessor: "newBalance", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Posted Date", accessor: "createdAt", Cell: ({ value }) => (value ? new Date(value).toLocaleString() : "") }
    ],
    []
  );

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <BeautifulTable
          columns={columns}
          data={business}
          pageSize={10}
          onRowClick={(row) => props.history?.push && props.history.push(`/dashboard/business/${row.id || row._id}`)}
        />
      </div>
    </div>
  );
};

export default BusinessUser;
